(() => {
  if (window.__threadlyHeaderCurrentShirtAssetRuntimeBound) return;
  window.__threadlyHeaderCurrentShirtAssetRuntimeBound = true;

  const ICON_URL = '/cdn/shop/t/6/assets/tshirt_icon_eigenes_svg_4px_dicker_transparent.svg';
  const TARGET_PATH = '/products/custom-levyo-shirt';

  function syncHeaderCurrentShirtIcon() {
    const link = document.querySelector('#cart-icon-bubble');
    if (!link) return;

    link.href = TARGET_PATH;
    link.setAttribute('aria-label', 'Open Levyo Maker');
    link.setAttribute('data-threadly-header-current-shirt', '');
    link.setAttribute('data-threadly-maker-current-shirt-icon', 'true');
    link.classList.add('threadly-header-current-shirt');
    link.querySelectorAll('.cart-count-bubble').forEach((bubble) => bubble.remove());

    let wrapper = link.querySelector('.svg-wrapper');
    if (!wrapper) {
      wrapper = document.createElement('span');
      wrapper.className = 'svg-wrapper';
      wrapper.setAttribute('aria-hidden', 'true');
      link.prepend(wrapper);
    }

    wrapper.style.width = '4.4rem';
    wrapper.style.height = '4.4rem';
    wrapper.style.display = 'grid';
    wrapper.style.placeItems = 'center';
    wrapper.style.lineHeight = '0';

    let icon = wrapper.querySelector('img[src*="tshirt_icon_eigenes_svg_4px_dicker_transparent.svg"]');
    if (!icon) {
      wrapper.textContent = '';
      icon = document.createElement('img');
      icon.src = ICON_URL;
      icon.alt = 'Levyo Maker shirt icon';
      icon.decoding = 'async';
      icon.setAttribute('aria-hidden', 'true');
      icon.setAttribute('draggable', 'false');
      wrapper.append(icon);
    }

    icon.alt = 'Levyo Maker shirt icon';
    icon.style.width = '2.8rem';
    icon.style.height = 'auto';
    icon.style.maxHeight = '2.5rem';
    icon.style.display = 'block';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncHeaderCurrentShirtIcon, { once: true });
  } else {
    syncHeaderCurrentShirtIcon();
  }

  window.addEventListener('pageshow', syncHeaderCurrentShirtIcon);
  document.addEventListener('shopify:section:load', syncHeaderCurrentShirtIcon);
  document.addEventListener('cart:updated', syncHeaderCurrentShirtIcon);

  const observer = new MutationObserver(syncHeaderCurrentShirtIcon);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    if (cartLink.hasAttribute('data-threadly-header-current-shirt')) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
